import { createReducer } from '../utils/helpers';
import constants from '../constants';

const {
  FETCH_ENTRIES_REQUEST,
  FETCH_ENTRIES_SUCCESS,
  FETCH_ENTRIES_FAILURE,
  CREATE_ENTRY_REQUEST,
  CREATE_ENTRY_SUCCESS,
  CREATE_ENTRY_FAILURE,
  DELETE_ENTRY_REQUEST,
  DELETE_ENTRY_SUCCESS,
  DELETE_ENTRY_FAILURE,
  EDIT_ENTRY_REQUEST,
  EDIT_ENTRY_SUCCESS,
  EDIT_ENTRY_FAILURE,
} = constants;

const initialState = {
  entries: [],
  isFetchingData: false,
  isPushingData: false,
  isDeletingData: false,
};

export default createReducer(initialState, {
  [FETCH_ENTRIES_REQUEST]: state => ({
    ...state,
    ...{
      entries: [],
      isFetchingData: true,
    },
  }),
  [FETCH_ENTRIES_SUCCESS]: (state, payload) => {
    const { entries } = payload;

    return {
      ...state,
      ...{
        entries,
        isFetchingData: false,
      },
    };
  },
  [FETCH_ENTRIES_FAILURE]: state => ({
    ...state,
    ...{
      entries: [],
      isFetchingData: false,
    },
  }),

  [CREATE_ENTRY_SUCCESS]: (state, payload) => ({
    ...state,
    ...{
      entries: [...state.entries, payload.entry],
      isPushingData: false,
    },
  }),
  [CREATE_ENTRY_FAILURE]: state => ({
    ...state,
    ...{
      isPushingData: false,
    },
  }),
  [CREATE_ENTRY_REQUEST]: state => ({
    ...state,
    ...{
      isPushingData: true,
    },
  }),

  [DELETE_ENTRY_SUCCESS]: (state, payload) => {
    const idx = state.entries.map(entry => entry.id).indexOf(payload.entry.id);

    return {
      ...state,
      ...{
        entries: [...state.entries.slice(0, idx), ...state.entries.slice(idx + 1)],
        isDeletingData: false,
      },
    };
  },
  [DELETE_ENTRY_FAILURE]: state => ({
    ...state,
    ...{
      isDeletingData: false,
    },
  }),
  [DELETE_ENTRY_REQUEST]: state => ({
    ...state,
    ...{
      isDeletingData: true,
    },
  }),

  [EDIT_ENTRY_SUCCESS]: (state, payload) => {
    const idx = state.entries.map(entry => entry.id).indexOf(payload.entry.id);

    return {
      ...state,
      ...{
        entries: [...state.entries.slice(0, idx), payload.entry, ...state.entries.slice(idx + 1)],
        isPushingData: false,
      },
    };
  },
  [EDIT_ENTRY_FAILURE]: state => ({
    ...state,
    ...{
      isPushingData: false,
    },
  }),
  [EDIT_ENTRY_REQUEST]: state => ({
    ...state,
    ...{
      isPushingData: true,
    },
  }),
});



// WEBPACK FOOTER //
// ./src/reducers/entries.js